/** Copyright (c) 2020 T.Rowe Price. All rights reserved. */

import './BrokerageExperience.scss';

import React, { Fragment, useEffect, useState } from "react";
import { connect } from 'react-redux';

import { getQueryParams } from 'state/session/SessionSelectors';
import ThirdPartyFrame from 'components/shared/ThirdPartyFrame/ThirdPartyFrame';
import { postExternalAuthorization } from 'services/Rest';
import { getBrokerageSSOData } from 'state/brokerage/BrokerageSelectors';
import { getBrokerageAccounts, mapProductTypeToiiFooterBoolean } from "state/account/AccountSelectors";
import {
  getHasReceivedAccounts,
  getRequestStatus
} from 'state/requests/RequestStatusSelectors';
import { arrayOfAccountDescriptors } from 'services/Accounts';
import { brokerageAuthTokenUrls } from 'services/Externals';
import BrokerageErrorPage from "components/shared/ErrorPage/BrokerageErrorPage";
import AAMFooterContainer, { BrokerageFootnote } from "components/layouts/Footer/FooterUtil";
import { non529OnlyLRNTaxesDashboardAccountsBenefits } from "services/FeatureFlags";
import LegalReferenceNumber from "components/layouts/LegalReferenceNumber/LegalReferenceNumber";
import { isMobile, isSalesforceRepEnabled } from "state/view/ViewSelectors";
import { hasAppLoaded } from "state/analytics/analyticsSelectors";
import { isDashboardOrAccounts } from "state/router/RouterSelectors";

const BrokerageExperience = ({
  appLoaded,
  brokerageAgreements,
  brokerageEligible,
  footerProductTypes,
  hasReceivedAccounts,
  isDashboardOrAccounts,
  isMobileApp,
  isSalesforceRepEnabled,
  params
}) => {

  const [hasError, setHasError] = useState(false)

  const {
    selectedAccountId,
    target
  } = params;

  const TARGET_MAPPING = {
    ['MF_TRADING'] : 'MUTUAL_FUND',
    ['TRADING'] : 'EQUITY',
    ['OPT_TRADING'] : 'EQUITY'
  }

  // const selectedBrokerageAccount = brokerageAgreements.find(b => b.accountId === selectedAccountId);

  const [samlData, setSAMLData] = useState({});

  useEffect(() => {
    if (hasReceivedAccounts) {
      // const preSelectedAccountNumber = selectedBrokerageAccount ? `${selectedBrokerageAccount.accountNumber}${selectedBrokerageAccount.accountChecksum}` : undefined

      const postBody = {
        accountDescriptors: arrayOfAccountDescriptors(brokerageAgreements),
        errorUrl: brokerageAuthTokenUrls.errorUrl,
        keepAliveUrl: brokerageAuthTokenUrls.keepAliveUrl,
        serviceTypeId: '701'
      };

      if(TARGET_MAPPING[target] && target !== TARGET_MAPPING.OPT_TRADING) {
        postBody.pershingNXITradingSubType = TARGET_MAPPING[target];
      }

      if(selectedAccountId && selectedAccountId.toLowerCase() !== 'undefined'){
        postBody.selectedAccountId = `${selectedAccountId}`
      }

      postExternalAuthorization(postBody)
        .then((res) => {
          setSAMLData(res);
        })
        .catch((err) => {
          if (err && err.serviceErrorCode) {
            setHasError(true);
          }
        });
    }
  }, [hasReceivedAccounts]);

  const { containerApplicationUrl, assertionText } = samlData;

  return (
    <div className="brokerage-experience-page">
      <div className="brokerage-experience-container">
        {hasError && (
          <BrokerageErrorPage headline={"We are having technical issues connecting to your brokerage account(s)."}/>
        )}
        {!hasError && (
          <Fragment>
          <ThirdPartyFrame
            eligible={brokerageEligible && !hasError}
            scrolling={'no'}
            name={'brokerage-experience'}
            errorUrl={'/error'}
            message={assertionText}
            params={{
              SSOIndicator: 'NXI_SSOIN_IDPINIT_TROWE',
              Target: target ? target : 'TRADING'
          }}
            containerURL={containerApplicationUrl}
          />
          </Fragment>
        )}
      </div>
      <BrokerageFootnote
        isDashboardOrAccounts={isDashboardOrAccounts}
        hasBrokerage={brokerageAgreements.length > 0}
      />
      {non529OnlyLRNTaxesDashboardAccountsBenefits() && (
        <LegalReferenceNumber/>
      )}
      {!isSalesforceRepEnabled && (
        <AAMFooterContainer
          isMobileParam={isMobileApp}
          footerProductTypes={footerProductTypes}
          appLoaded={appLoaded}
        />
      )}
    </div>
  );
};

const mapStateToProps = (state) => ({
  params: getQueryParams(state),
  footerProductTypes: mapProductTypeToiiFooterBoolean(state),
  appLoaded: hasAppLoaded(state),
  isDashboardOrAccounts: isDashboardOrAccounts(state),
  isMobileApp: isMobile(state),
  isSalesforceRepEnabled: isSalesforceRepEnabled(state),
  hasReceivedAccounts: getHasReceivedAccounts(state),
  brokerageAgreements: getBrokerageAccounts(state),
  brokerageEligible: true,
  requestStatus: getRequestStatus(state),
  sso: getBrokerageSSOData(state)
});

export default connect(mapStateToProps)(BrokerageExperience);
